import { useState } from 'react';
import { ScanSearch } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { OpenGamesBody } from './OpenGamesPicks';
import { OpenPropsBody } from './OpenPropsPicks';

const TABS = [['props', 'Player props'], ['teams', 'Team winners']];

// One button: picks not on my active tickets — player props (skip players I have) or team winners (skip games I have).
const NAME = { nfl: 'NFL', nba: 'NBA', cfb: 'college football' };
const WHEN = { nfl: 'the next NFL game day', nba: "tonight's NBA games", cfb: "this week's college games" };

export default function PicksNotOnTickets({ league = 'nfl' }) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(league === 'cfb' ? 'teams' : 'props');
  const tabs = league === 'cfb' ? TABS.filter(([k]) => k === 'teams') : TABS;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={league === 'nfl' ? 'not-on-tickets-btn' : `not-on-tickets-btn-${league}`}
        className="w-full flex items-center justify-between gap-3 rounded-xl border border-cyan-500/50 bg-cyan-500/10 p-3 text-left hover:bg-cyan-500/20 transition-colors">
        <div>
          <p className="text-sm font-bold text-cyan-300 flex items-center gap-1.5"><ScanSearch className="w-4 h-4" /> Picks not on my tickets</p>
          <p className="text-[11px] text-zinc-400">Checks every ticket below · {league === 'cfb' ? 'team winners' : 'player props and team winners'} for {WHEN[league]}</p>
        </div>
        <span className="shrink-0 rounded-lg bg-cyan-400 px-3 py-1.5 text-xs font-bold text-black">Analyze</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-zinc-950 border-zinc-800 text-white max-w-lg max-h-[88vh] overflow-y-auto overflow-x-hidden" data-testid="not-on-tickets-dialog">
          <DialogHeader>
            <DialogTitle>Picks not on your tickets</DialogTitle>
            <DialogDescription className="text-zinc-400 text-xs">{NAME[league]} · only games that haven't started</DialogDescription>
          </DialogHeader>
          <div className="flex gap-1.5" data-testid="not-on-tickets-tabs">
            {tabs.map(([k, l]) => (
              <button key={k} type="button" onClick={() => setTab(k)} data-testid={`not-on-tickets-tab-${k}`}
                className={`rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${tab === k ? 'bg-cyan-400 text-black border-cyan-400' : 'border-zinc-700 text-zinc-400 hover:text-white'}`}>{l}</button>
            ))}
          </div>
          {open && (tab === 'props' ? <OpenPropsBody key="props" league={league} /> : <OpenGamesBody key="teams" league={league} />)}
        </DialogContent>
      </Dialog>
    </>
  );
}
